export enum AccountType {
  INDIVIDUAL = 'Individual',
  ORGANIZATION = 'Organization',
}
